import { Injectable, EventEmitter, Output } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
// import { analyzeAndValidateNgModules, Type } from "@angular/compiler";
import { Observable, Subject } from "rxjs";
import { AuthPayloadService } from './auth-payload';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: "root",
})
export class MedicinService {
  private subject = new Subject<any>();
  APIResponse: any;
  BaseURL1: string = "https://hdrx.23byt.es/api/v1/";
  BaseURL2: string = "https://hdrx.23byt.es/api/v2/";
  BaseURL3: string = "https://hdrx.23byt.es/api/v3/";
  BaseURL: string = environment.api.baseUrl;
  GeoBaseURL: string = "https://maps.googleapis.com/maps/api/geocode/json?";

  showloginbox = false;
  signup_fields = false;
  signin_fields = false;

  constructor(public http: HttpClient, private authPayloadService: AuthPayloadService) { }

  private addAuthPayload(formData: any): any {
    const payload = this.authPayloadService.generatePayload();
    return { ...formData, ...payload };
  }

  /** False on SSR/Node so dev endpoints are used when host is unavailable. */
  private isProductionHost(): boolean {
    if (typeof location === 'undefined' || !location.host) {
      return false;
    }
    return location.host === 'glicrx.com' || location.host === 'www.glicrx.com';
  }

  private storageGet(key: string): string | null {
    if (typeof window === 'undefined' || !window.localStorage) {
      return null;
    }
    return window.localStorage.getItem(key);
  }

  private getPageUrl(): string {
    if (typeof window !== 'undefined' && window.location) {
      return window.location.href;
    }
    return '';
  }

  PostDomainPDF(ftext, Pdf64Code): Observable<any> {
    var ftextE = encodeURIComponent(ftext);
    let formData = { "ftext": ftextE, "pdf64": Pdf64Code };
    const params = new HttpParams({ fromObject: formData });
    return this.http.post(this.BaseURL2 + "Savepdf", params.toString(), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  }
  
  PostDomainAffiliate(vender, group, pcn, subText, Image64Code, Desc): Observable<any> {
    var venderE = encodeURIComponent(vender);
    var groupE = encodeURIComponent(group);
    var pcnE = encodeURIComponent(pcn);
    var subTextE = encodeURIComponent(subText);
    let formData = { "vname": venderE, "group": groupE, "pcn": pcnE, "ftext": subTextE, "Image64Code": Image64Code, "desc": Desc };
    const params = new HttpParams({ fromObject: formData });
    return this.http.post(this.BaseURL2 + "SaveAffilliate", params.toString(), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  }
  
  OpenPdf(ftext): Observable<any> {
    var subTextE = encodeURIComponent(ftext);
    let formData = { "ftext": subTextE, "pdf64": "pdf" };
    const params = new HttpParams({ fromObject: formData });
    return this.http.post(this.BaseURL2 + "GetPDF", params.toString(), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  }
  
  GetDomainAffiliate(stext): Observable<any> {
    var Gstext = encodeURIComponent(stext);
    let formData = { "stext": Gstext };
    const params = new HttpParams({ fromObject: formData });
    return this.http.post(this.BaseURL2 + "GetAffilliate", params.toString(), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  }
  
  SearchDomainAffiliate(stext): Observable<any> {
    var Gstext = encodeURIComponent(stext);
    let formData = { "stext": Gstext };
    const params = new HttpParams({ fromObject: formData });
    return this.http.post(this.BaseURL2 + "GetAffilliate", params.toString(), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  }
  
  GetFaq(): Observable<any> {
    let formData = { "DrugName": "english" };
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const formDataWithAuth = this.addAuthPayload(formData);
    const params = new HttpParams({ fromObject: formDataWithAuth });
    return this.http.post(environment.api.baseUrl + "faqs", params.toString(), { headers });
  }
  
  GetDefaultCard(AppName): Observable<any> {
    const authPayload = this.authPayloadService.generatePayload();
    const bodyData = 'AppName=' + encodeURIComponent(AppName) + 
                     '&AppType=WebApp' + 
                     '&challenge=' + authPayload.challenge + 
                     '&timestamp=' + authPayload.timestamp + 
                     '&nonce=' + authPayload.nonce + 
                     '&signature=' + authPayload.signature + 
                     '&appname=' + authPayload.appname;
    return this.http.post(environment.api.baseUrl + "defaultcard", bodyData, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  }
  SaveDeeplink(email: string, fname: string, lname: string, groupnumber?: string, deeplink?: string, ecenter?: string): Observable<any> {
    const key = btoa('glicrx:hj78y64re3kl899078h6');
    const authPayload = this.authPayloadService.generatePayload();
    const headers = new HttpHeaders({
      'Authorization': 'Basic ' + key,
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
    });

    const body = `Fname=${fname}&Lname=${lname}&Email=${encodeURIComponent(email)}&Gn=${groupnumber}&DeepLink=${deeplink}&UserAgent=Web&Ecenter=${ecenter}&ListId=${this.storageGet('klaviyoid') ?? ''}&challenge=${authPayload.challenge}&timestamp=${authPayload.timestamp}&nonce=${authPayload.nonce}&signature=${authPayload.signature}&appname=${authPayload.appname}`;

    const url = this.isProductionHost() ?
      this.BaseURL + 'storedl' :
      this.BaseURL + 'storedl_dev';

    return this.http.post<any>(url, body, { headers });
  }
  
  lastLoginStatus(getUserId, getUserEmail): Observable<any> {
    const authPayload = this.authPayloadService.generatePayload();
    const bodyData = 'UserId=' + encodeURIComponent(getUserId) + 
                     '&UserEmail=' + encodeURIComponent(getUserEmail) + 
                     '&challenge=' + authPayload.challenge + 
                     '&timestamp=' + authPayload.timestamp + 
                     '&nonce=' + authPayload.nonce + 
                     '&signature=' + authPayload.signature + 
                     '&appname=' + authPayload.appname;
    return this.http.post(environment.api.baseUrl + "VerifyUser", bodyData, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  }
  brokerLogin(email, password) {
    const urlapi = this.isProductionHost()
      ? 'https://cors.23byt.es/https://reporting.glichealth.com/api/v1/BrokerOauth'
      : 'https://cors.23byt.es/https://dev.glichealth.com/api/v1/BrokerOauth';
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = { 'email': email, 'password': password };
    return this.http.post(urlapi, body, { headers });
  }

  eccount(email, groupnumberr, uid) {
    const urlapi = this.isProductionHost()
      ? 'https://cors.23byt.es/https://reporting.glichealth.com/api/v1/Broker_Enrolls'
      : 'https://cors.23byt.es/https://dev.glichealth.com/api/v1/Broker_Enrolls';
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = { 'email': email, 'groupnumber': groupnumberr, 'userid': uid };
    return this.http.post(urlapi, body, { headers });
  }

  recoverAccesscode(email) {
    const urlapi = this.isProductionHost()
      ? 'https://cors.23byt.es/https://reporting.glichealth.com/api/v1/broker_accesscode'
      : 'https://cors.23byt.es/https://dev.glichealth.com/api/v1/broker_accesscode';
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = { 'UserEmail': email, 'RequestURL': this.getPageUrl() };
    return this.http.post(urlapi, body, { headers });
  }

  changesignstatus(id, email, groupnumberr, pref) {
    const urlapi = this.isProductionHost()
      ? 'https://cors.23byt.es/https://reporting.glichealth.com/api/v1/brsignsetting'
      : 'https://cors.23byt.es/https://dev.glichealth.com/api/v1/brsignsetting';
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let body = {
      'id': id,
      'email': email,
      'gn': groupnumberr,
      'pref': pref
    }
    return this.http.post(urlapi, body, { headers });
  }

  addsignature(id, email, groupnumberr, sfullname, scompanyname, semail, sphone) {
    const urlapi = this.isProductionHost()
      ? 'https://cors.23byt.es/https://reporting.glichealth.com/api/v1/brsigndetail'
      : 'https://cors.23byt.es/https://dev.glichealth.com/api/v1/brsigndetail';
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let body = {
      'id': id,
      'email': email,
      'gn': groupnumberr,
      'sfullname': sfullname,
      'scompanyname': scompanyname,
      'semail': semail,
      'sphone': sphone
    }
    return this.http.post(
      urlapi,
      body,
      { headers: headers }
    );
  }
  SearchDrugList(searchtext): Observable<any> {
    var Encode_DrugName = encodeURIComponent(searchtext);
    let formData = { "stext": Encode_DrugName };
    const params = new HttpParams({ fromObject: formData });
    return this.http.post(environment.api.baseUrl + "searchdrug ", params.toString(), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  }
  GetDrugList(searchtext = 'GlicRx'): Observable<any> {
    let formData = { "stext": searchtext };
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const formDataWithAuth = this.addAuthPayload(formData);
    const params = new HttpParams({ fromObject: formDataWithAuth });
    return this.http.post(environment.api.baseUrl + "GetDrugList", params.toString(), { headers });
  }
  GetPopularDrug(): Observable<any> {
    let formData = { "DrugName": "test" };
    const params = new HttpParams({ fromObject: formData });
    return this.http.post(environment.api.baseUrl + "populardrug ", params.toString(), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  }

  GetDrugDetails(drugName: string): Observable<any> {
    // const encodeDrugName = encodeURIComponent(drugName);
    //const params = new HttpParams().set('DrugName', drugName);
    const formData = { "DrugName": drugName };
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8');
    const formDataWithAuth = this.addAuthPayload(formData);
    const params = new HttpParams({ fromObject: formDataWithAuth });
    return this.http.post(environment.api.baseUrl + 'drugcomponents', params.toString(), { headers });
  }
  
  GetCoordinatebyzip(ZipCode): Observable<any> { 
    let formData = { "address": ZipCode, "AppName": "glicrx" };
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const formDataWithAuth = this.addAuthPayload(formData);
    const params = new HttpParams({ fromObject: formDataWithAuth });
    return this.http.post(environment.api.baseUrl + 'geoaddress', params.toString(), { headers });
  }

  GetLocationByLatLongWithSensor(Lat, Long): Observable<any> { 
    let formData = { "AppName": "glicrx", "lat": Lat, "lng": Long };
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const formDataWithAuth = this.addAuthPayload(formData);
    const params = new HttpParams({ fromObject: formDataWithAuth });
    return this.http.post(environment.api.baseUrl + 'reversegeo', params.toString(), { headers });
  }
  GetPharmacyList(Lat, Long, GPId, Quantity, Dosage, Type, MultiSource, DrugName, UserId, ZipCode, UserLocation, ResponseType): Observable<any> {
    var Encode_DrugName = decodeURIComponent(DrugName);
    let formData = { "Lat": Lat, "Long": Long, "GpId": GPId, "Quant": this.storageGet('DrugQuant'), "Dosage": Dosage, "Type": Type, "MultiSource": MultiSource, "DrugName": Encode_DrugName, "UserId": UserId, "ZipCode": ZipCode, "Userlocation": UserLocation, "ResponseType": ResponseType, "NDCCode": this.storageGet('ndccode'), "DisplayQuant": this.storageGet('displayquantity') };
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const formDataWithAuth = this.addAuthPayload(formData);
    const params = new HttpParams({ fromObject: formDataWithAuth });
    return this.http.post(environment.api.baseUrl + "pharmacy", params.toString(), { headers });
  }
  
  CreateAccount(EmailId, Password, groupnumber): Observable<any> {
    let formData = { "email": EmailId, "password": Password, "groupnumber": groupnumber, "platform": "web" };
    const params = new HttpParams({ fromObject: formData });
    return this.http.post(this.BaseURL1 + "signup ", params.toString(), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  }
  // LoginAccount(EmailId, Password) {
  //   let headers = new HttpHeaders();
  //   headers.append(
  //     "Content-Type",
  //     "application/x-www-form-urlencoded; charset=utf-8"
  //   );
  //   return this.http.post(
  //     this.BaseURL1 + "signin",
  //     "email=" + EmailId + "&password=" + Password,
  //     { headers: headers }
  //   );
  // }
  LoginAccount(EmailId, Password): Observable<any> {
    let formData = { "email": EmailId, "password": Password };
    const params = new HttpParams({ fromObject: formData });
    return this.http.post(this.BaseURL1 + "signin ", params.toString(), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  }
  // ForgotPassword(EmailId) {
  //   let headers = new HttpHeaders();
  //   headers.append(
  //     "Content-Type",
  //     "application/x-www-form-urlencoded; charset=utf-8"
  //   );
  //   return this.http.post(this.BaseURL1 + "passwordreset", "email=" + EmailId, {
  //     headers: headers,
  //   });
  // }
  ForgotPassword(EmailId): Observable<any> {
    let formData = { "email": EmailId };
    const params = new HttpParams({ fromObject: formData });
    return this.http.post(this.BaseURL1 + "passwordreset ", params.toString(), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  }
  // SaveUserCards(
  //   UserId,
  //   UserCharId,
  //   PharmacyName,
  //   PharmacyType,
  //   DrugName,
  //   Price,
  //   Quantity,
  //   Dose,
  //   Form,
  //   PharmacyPhone,
  //   Address1,
  //   Address2,
  //   GpId,
  //   MultiSource,
  //   Bin,
  //   Pcn,
  //   DialNumber,
  //   Plogo
  // ) {
  //   var Encode_DrugName = encodeURIComponent(DrugName);
  //   var Encode_PharmacyName = encodeURIComponent(PharmacyName);
  //   let headers = new HttpHeaders();
  //   headers.append(
  //     "Content-Type",
  //     "application/x-www-form-urlencoded; charset=utf-8"
  //   );
  //   return this.http.post(
  //     this.BaseURL1 + "card",
  //     "UserId=" +
  //     UserId +
  //     "&UserCharId=" +
  //     UserCharId +
  //     "&PharmacyName=" +
  //     Encode_PharmacyName +
  //     "&PharmacyType=" +
  //     PharmacyType +
  //     "&DrugName=" +
  //     Encode_DrugName +
  //     "&Price=" +
  //     Price +
  //     "&Quantity=" +
  //     Quantity +
  //     "&Dose=" +
  //     Dose +
  //     "&Form=" +
  //     Form +
  //     "&PharmacyPhone=" +
  //     PharmacyPhone +
  //     "&Address1=" +
  //     Address1 +
  //     "&Address2=" +
  //     Address2 +
  //     "&GPId=" +
  //     GpId +
  //     "&Bin=" +
  //     Bin +
  //     "&Pcn=" +
  //     Pcn +
  //     "&Pbmphone=" +
  //     DialNumber +
  //     "&Plogo=" +
  //     Plogo +
  //     "&MultiSource=" +
  //     MultiSource,
  //     { headers: headers }
  //   );
  // }
  SaveUserCards(UserId, UserCharId, PharmacyName, PharmacyType, DrugName, Price, Quantity, Dose, Form, PharmacyPhone, Address1, Address2, GpId, MultiSource, Bin, Pcn, DialNumber, Plogo): Observable<any> {
    var Encode_DrugName = encodeURIComponent(DrugName);
    var Encode_PharmacyName = encodeURIComponent(PharmacyName);
    let formData = { "UserId": UserId, "UserCharId": UserCharId, "PharmacyName": Encode_PharmacyName, "PharmacyType": PharmacyType, "DrugName": Encode_DrugName, "Price": Price, "Quantity": Quantity, "Dose": Dose, "Form": Form, "PharmacyPhone": PharmacyPhone, "Address1": Address1, "Address2": Address2, "GPId": GpId, "Bin": Bin, "Pcn": Pcn, "Pbmphone": DialNumber, "Plogo": Plogo, "MultiSource": MultiSource };
    const params = new HttpParams({ fromObject: formData });
    return this.http.post(this.BaseURL1 + "card ", params.toString(), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  }
  // GetUserCards(UserId) {
  //   let headers = new HttpHeaders();
  //   headers.append(
  //     "Content-Type",
  //     "application/x-www-form-urlencoded; charset=utf-8"
  //   );
  //   return this.http.post(this.BaseURL1 + "usercard", "UserId=" + UserId, {
  //     headers: headers,
  //   });
  // }
  GetUserCards(UserId): Observable<any> {
    let formData = { "UserId": UserId };
    const params = new HttpParams({ fromObject: formData });
    return this.http.post(this.BaseURL1 + "usercard ", params.toString(), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  }
  // RemoveSavedCard(UserId, CardId) {
  //   let headers = new HttpHeaders();
  //   headers.append(
  //     "Content-Type",
  //     "application/x-www-form-urlencoded; charset=utf-8"
  //   );
  //   return this.http.post(
  //     this.BaseURL2 + "RemoveCard",
  //     "UserId=" + UserId + "&cardId=" + CardId,
  //     { headers: headers }
  //   );
  // }
  RemoveSavedCard(UserId, CardId): Observable<any> {
    let formData = { "UserId": UserId, "cardId": CardId };
    const params = new HttpParams({ fromObject: formData });
    return this.http.post(this.BaseURL1 + "RemoveCard ", params.toString(), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  }

  // SaveUserShareCard(
  //   UserId,
  //   MemeberId,
  //   DrugName,
  //   Quantity,
  //   DrugForm,
  //   DrugDose,
  //   DrugPrice,
  //   PharmacyName,
  //   Address1,
  //   Address2,
  //   PPhone,
  //   Bin,
  //   PCN,
  //   GroupNumber,
  //   UserEmail,
  //   PHelpLine,
  //   Localuser
  // ) {
  //   var Encode_DrugName = encodeURIComponent(DrugName);
  //   var Encode_PharmacyName = encodeURIComponent(PharmacyName);
  //   let headers = new HttpHeaders();
  //   headers.append(
  //     "Content-Type",
  //     "application/x-www-form-urlencoded; charset=utf-8"
  //   );
  //   return this.http.post(
  //     this.BaseURL2 + "dc",
  //     "UId=" +
  //     UserId +
  //     "&MId=" +
  //     MemeberId +
  //     "&Dname=" +
  //     Encode_DrugName +
  //     "&Q=" +
  //     Quantity +
  //     "&Form=" +
  //     DrugForm +
  //     "&Dose=" +
  //     DrugDose +
  //     "&Price=" +
  //     DrugPrice +
  //     "&Pname=" +
  //     Encode_PharmacyName +
  //     "&Ad1=" +
  //     Address1 +
  //     "&Ad2=" +
  //     Address2 +
  //     "&Phone=" +
  //     PPhone +
  //     "&Bin=" +
  //     Bin +
  //     "&PCN=" +
  //     PCN +
  //     "&GN=" +
  //     GroupNumber +
  //     "&Email=" +
  //     UserEmail +
  //     "&HL=" +
  //     PHelpLine +
  //     "&User=" +
  //     Localuser,
  //     { headers: headers }
  //   );
  // }
  SaveUserShareCard(UserId, MemeberId, DrugName, Quantity, DrugForm, DrugDose, DrugPrice, PharmacyName, Address1, Address2, PPhone, Bin, PCN, GroupNumber, UserEmail, PHelpLine, Localuser): Observable<any> {
    var Encode_DrugName = decodeURIComponent(DrugName);
    var Encode_PharmacyName = decodeURIComponent(PharmacyName);
    let formData = { "UId": UserId, "MId": MemeberId, "Dname": Encode_DrugName, "Q": Quantity, "Form": DrugForm, "Dose": DrugDose, "Price": DrugPrice, "Pname": Encode_PharmacyName, "Ad1": Address1, "Ad2": Address2, "Phone": PPhone, "Bin": Bin, "PCN": PCN, "GN": GroupNumber, "Email": UserEmail, "HL": PHelpLine, "User": Localuser };
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const formDataWithAuth = this.addAuthPayload(formData);
    const params = new HttpParams({ fromObject: formDataWithAuth });
    return this.http.post(environment.api.baseUrl + "dc", params.toString(), { headers });
  }
  // RemoveDiscountCard(
  //   UserId,
  //   MemeberId,
  //   DrugName,
  //   Quantity,
  //   DrugForm,
  //   DrugDose,
  //   DrugPrice,
  //   PharmacyName,
  //   Address1,
  //   Address2,
  //   PPhone,
  //   MultiSource,
  //   PType
  // ) {
  //   var Encode_DrugName = encodeURIComponent(DrugName);
  //   var Encode_PharmacyName = encodeURIComponent(PharmacyName);
  //   let headers = new HttpHeaders();
  //   headers.append(
  //     "Content-Type",
  //     "application/x-www-form-urlencoded; charset=utf-8"
  //   );
  //   return this.http.post(
  //     this.BaseURL2 + "RemoveDiscountCard",
  //     "UId=" +
  //     UserId +
  //     "&MId=" +
  //     MemeberId +
  //     "&Dname=" +
  //     Encode_DrugName +
  //     "&Q=" +
  //     Quantity +
  //     "&Form=" +
  //     DrugForm +
  //     "&Dose=" +
  //     DrugDose +
  //     "&Price=" +
  //     DrugPrice +
  //     "&Pname=" +
  //     Encode_PharmacyName +
  //     "&Ad1=" +
  //     Address1 +
  //     "&Ad2=" +
  //     Address2 +
  //     "&Phone=" +
  //     PPhone +
  //     "&Ms=" +
  //     MultiSource +
  //     "&Type=" +
  //     PType,
  //     { headers: headers }
  //   );
  // }
  RemoveDiscountCard(UserId, MemeberId, DrugName, Quantity, DrugForm, DrugDose, DrugPrice, PharmacyName, Address1, Address2, PPhone, MultiSource, PType): Observable<any> {
    var Encode_DrugName = encodeURIComponent(DrugName);
    var Encode_PharmacyName = encodeURIComponent(PharmacyName);
    let formData = { "UId": UserId, "MId": MemeberId, "Dname": Encode_DrugName, "Q": Quantity, "Form": DrugForm, "Dose": DrugDose, "Price": DrugPrice, "Pname": Encode_PharmacyName, "Ad1": Address1, "Ad2": Address2, "Phone": PPhone, "Ms": MultiSource, "Type": PType };
    const params = new HttpParams({ fromObject: formData });
    return this.http.post(this.BaseURL2 + "RemoveDiscountCard ", params.toString(), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  }
  // GNValidate(groupnumber) {
  //   let headers = new HttpHeaders();
  //   headers.append(
  //     "Content-Type",
  //     "application/x-www-form-urlencoded; charset=utf-8"
  //   );
  //   if (this.isProductionHost()) {
  //     return this.http.post(
  //       this.BaseURL3 + "checkgnstatus",
  //       "gn=" + groupnumber,
  //       { headers: headers }
  //     );
  //   }
  //   else {
  //     return this.http.post(
  //       this.BaseURL3 + "checkgnstatus_dev",
  //       "gn=" + groupnumber,
  //       { headers: headers }
  //     );
  //   }
  // }
  GNValidate(groupnumber, fname, lname, email, deeplink, memidsource, memid): Observable<any> {
    let formData = {
      "gn": groupnumber,
      "fname": fname,
      "lname": lname,
      "email": email,
      "deeplink": deeplink,
      "memidsource": memidsource,
      "memid": memid,
    };
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const formDataWithAuth = this.addAuthPayload(formData);
    const params = new HttpParams({ fromObject: formDataWithAuth });
    
    const endpoint = this.isProductionHost() ? 'checkgnstatus' : 'checkgnstatus_dev';
    
    return this.http.post(
      environment.api.baseUrl + endpoint,
      params.toString(),
      { headers }
    );
  }
  gethistorical(distId, emailId, groupNumber) {
    const authPayload = this.authPayloadService.generatePayload();
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let body = {
      "distId": distId,
      "emailId": emailId,
      "groupNumber": groupNumber,
      "challenge": authPayload.challenge,
      "timestamp": authPayload.timestamp,
      "nonce": authPayload.nonce,
      "signature": authPayload.signature,
      "appname": authPayload.appname
    }
    
    const endpoint = this.isProductionHost() ? 'enrolls' : 'enrolls_dev';
    
    return this.http.post(
      environment.api.baseUrl + endpoint,
      body,
      { headers: headers }
    );
  }


  // UpdateGroupNumber(UserId, GroupNumber) {
  //   let headers = new HttpHeaders();
  //   headers.append(
  //     "Content-Type",
  //     "application/x-www-form-urlencoded; charset=utf-8"
  //   );
  //   return this.http.post(
  //     this.BaseURL2 + "updategn",
  //     "UserId=" + UserId + "&UserGN=" + GroupNumber,
  //     { headers: headers }
  //   );
  // }
  UpdateGroupNumber(UserId, GroupNumber): Observable<any> {
    let formData = { "UserId": UserId, "UserGN": GroupNumber };
    const params = new HttpParams({ fromObject: formData });
    return this.http.post(this.BaseURL2 + "updategn ", params.toString(), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });

  }
  PushCardList() {
    if (typeof window === 'undefined' || !window.localStorage) {
      return;
    }
    try {
      if (
        this.storageGet("CardListLocally") != null ||
        this.storageGet("CardListLocally") != undefined
      ) {
        let CardListData = JSON.parse(
          this.storageGet("CardListLocally")
        );
        for (let x3 of CardListData) {
          this.SaveUserCards(
            this.storageGet("UserId"),
            this.storageGet("UserCharId"),
            x3.PharmacyName,
            x3.PharmacyType,
            x3.DrugName,
            x3.Price,
            x3.Quantity,
            x3.Dose,
            x3.Form,
            x3.PharmacyPhone,
            x3.Address1,
            x3.Address2,
            x3.GPId,
            x3.MultiSource,
            x3.BIN,
            x3.PCN,
            x3.PBMPhone,
            x3.LogoLink
          )
            // .pipe(map((res) => res.json()))
            .subscribe((data) => { });
        }
        window.localStorage.setItem("CardListLocally", null);
      }
    } catch { }
  }
  // ResetPassword(userid, cpassword, npassword) {
  //   let headers = new HttpHeaders();
  //   headers.append(
  //     "Content-Type",
  //     "application/x-www-form-urlencoded; charset=utf-8"
  //   );
  //   return this.http.post(
  //     this.BaseURL1 + "passwordupdate",
  //     "UserId=" +
  //     userid +
  //     "&CurrentPassword=" +
  //     cpassword +
  //     "&NewPassword=" +
  //     npassword,
  //     { headers: headers }
  //   );
  // }
  ResetPassword(userid, cpassword, npassword): Observable<any> {
    let formData = { "UserId": userid, "CurrentPassword": cpassword, "NewPassword": npassword };
    const params = new HttpParams({ fromObject: formData });
    return this.http.post(this.BaseURL1 + "passwordupdate ", params.toString(), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  }
  // RequestOTP_Forgotpassword(EmailId) {
  //   let headers = new HttpHeaders();
  //   headers.append(
  //     "Content-Type",
  //     "application/x-www-form-urlencoded; charset=utf-8"
  //   );
  //   return this.http.post(
  //     this.BaseURL1 + "otprequest",
  //     "useremail=" + EmailId,
  //     { headers: headers }
  //   );
  // }
  RequestOTP_Forgotpassword(EmailId): Observable<any> {
    let formData = { "useremail": EmailId };
    const params = new HttpParams({ fromObject: formData });
    return this.http.post(this.BaseURL1 + "otprequest ", params.toString(), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  }
  // VerifyOTP_Forgotpassword(OTP, UserId) {
  //   let headers = new HttpHeaders();
  //   headers.append(
  //     "Content-Type",
  //     "application/x-www-form-urlencoded; charset=utf-8"
  //   );
  //   return this.http.post(
  //     this.BaseURL1 + "otpverify",
  //     "OTP=" + OTP + "&UserId=" + UserId,
  //     { headers: headers }
  //   );
  // }
  VerifyOTP_Forgotpassword(OTP, UserId): Observable<any> {
    let formData = { "OTP": OTP, "UserId": UserId };
    const params = new HttpParams({ fromObject: formData });
    return this.http.post(this.BaseURL1 + "otpverify ", params.toString(), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  }
  // VerifyOTP_Resetpassword(UserId, Password) {
  //   let headers = new HttpHeaders();
  //   headers.append(
  //     "Content-Type",
  //     "application/x-www-form-urlencoded; charset=utf-8"
  //   );
  //   return this.http.post(
  //     this.BaseURL1 + "forgetresetpassword",
  //     "UserId=" + UserId + "&Password=" + Password,
  //     { headers: headers }
  //   );
  // }
  VerifyOTP_Resetpassword(UserId, Password): Observable<any> {
    let formData = { "UserId": UserId, "Password": Password };
    const params = new HttpParams({ fromObject: formData });
    return this.http.post(this.BaseURL1 + "forgetresetpassword ", params.toString(), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  }
  // GetWhiteParams() {
  //   let headers = new HttpHeaders();
  //   headers.append(
  //     "Content-Type",
  //     "application/x-www-form-urlencoded; charset=utf-8"
  //   );
  //   return this.http.post(this.BaseURL2 + "whiteparam", "stext=" + "test", {
  //     headers: headers,
  //   });
  // }
  GetWhiteParams(): Observable<any> {
    let formData = { "stext": "test" };
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const formDataWithAuth = this.addAuthPayload(formData);
    const params = new HttpParams({ fromObject: formDataWithAuth });
    return this.http.post(environment.api.baseUrl + "whiteparam", params.toString(), { headers });
  }
  IsNullOrEmptyField(input: string) {
    if (input == "" || input == undefined || input == null) return true;
    else return false;
  }

  Setsignup(box, signup, signin) {
    this.showloginbox = box;
    this.signup_fields = signup;
    this.signin_fields = signin;
  }
  Getsignup() {
    let xyz: any = [];
    return (xyz = [this.showloginbox, this.signup_fields, this.signin_fields]);
  }

  sendMessage(message: string) {
    this.subject.next({ text: message });
  }

  clearMessages() {
    this.subject.next(null);
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
  // get your card
}